GP.collections.Content = Backbone.Collection.extend({
    model: GP.models.Content,
    comparator: function(data) {
        if (!GP.Util.check_location('/content/pictures') && !GP.Util.check_location('/content/videos')) {
            var id = parseInt(data.get('content_id'), 10);
            return -id;
        }
    },

    // url: '/members/user/profile',
    // comparator: function(data) {
    //     return data.get('content_id');
    // },    
    // parse: function(data) {
    //     // Hide "load more" button if no more content
    //     if (data.show_load_more === false && data.page == 'profile') {
    //         GP.vent.trigger('Content:hide_profile_load_more');
    //     }
    //     return data.content;
    // },
    initialize: function(data) {

    }
});
